export const THREE_AND_SEVEN_YEARS = 1;
export const THIRTEEN_YEARS = 2;
export const NINETEEN_YEARS = 3;
export const TWENTYTHREE_YEARS = 4;
export const ONE_TO_SIX_YEARS = 5;
export const SEVEN_TO_EIGHTEEN_YEARS = 6;
export const NINETEEN_TO_TWENTYTHREE_YEARS = 7;